import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import CoordinateNotificationCenter from './CoordinateNotificationCenter';

const CoordinateLayout: React.FC = () => {
  const location = useLocation();

  if (location.pathname === '/coordinate' || location.pathname === '/coordinate/') {
    return <Navigate to="/coordinate/patients" replace />;
  }

  return (
    <>
      <Outlet />
      <CoordinateNotificationCenter />
    </>
  );
};

export default CoordinateLayout;
